<template>
  <aside class="app-notice">
    <slot name="title"></slot>
    <slot></slot>
  </aside>
</template>

<script setup>
// The component name is automatically inferred from the file name.

</script>

<style scoped lang="scss">
.app-notice {
  max-width: 38%;

  @media only screen and (max-width: 599px) {
    max-width: 100%;
  }
  @media only screen and (min-width: 600px) and (max-width: 1374px) {
    max-width: 100%;
  }
}

</style>
